var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.converted_stats),function(value,key){return _c('div',{key:key},[_c('div',{staticClass:"elevation-0",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticStyle:{"color":"var(--ks-font-color-title)","text-transform":"capitalize"}},[_vm._v(_vm._s(key))]),_c('k-key-value',{attrs:{"items":Object.entries(value).map(function (ref) {
	var k = ref[0];
	var v = ref[1];

	return ({key: k, value: v});
}),"key-width":'60%',"columns":"2"},scopedSlots:_vm._u([{key:"value",fn:function(ref){
var value = ref.value;
return [_c('k-chip',{attrs:{"outlined":"","size":"xs"}},[_vm._v(_vm._s(value))])]}}],null,true)})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }